/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Empty, Result } from 'antd';
import { CSSProperties } from 'react';
import { useAtomValue } from 'jotai';
import { ResultItem } from 'packages/polaris/tool/results/result-item';
import { LoadingResults } from 'packages/omnitag/results/results-layout';
import { filteredSearchResultsSelector } from 'packages/polaris/state/text-search';

export const stylesGrid: { [name: string]: CSSProperties } = {
  grid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1rem',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
};

export const ResultsGrid = (): JSX.Element | null => {
  const results = useAtomValue(filteredSearchResultsSelector);

  if (results && results.isValidating) {
    return <LoadingResults />;
  }

  // Ant's Result status only accepts 403, 404, and 500 codes.  However the title can be anything.
  const statusCode = results?.error?.response?.status ?? 'Error';

  if (results?.error)
    return (
      <Result
        style={{ placeSelf: 'center', width: '100%' }}
        status={500}
        title={statusCode}
        subTitle={`Sorry, something went wrong. ${results.error}`}
      />
    );
  if (!results || !Array.isArray(results.data)) {
    return (
      <Empty
        style={{ placeSelf: 'center', width: '100%' }}
        data-testid="omnitag-empty-description"
        description={<>Choose a search tag above</>}
      />
    );
  }
  if (results.data.length === 0) {
    return (
      <Empty
        style={{ placeSelf: 'center', width: '100%' }}
        description="Your query returned no results"
      />
    );
  }

  return (
    <div style={stylesGrid.grid}>
      {results.data.map((r) => (
        <ResultItem result={r} key={r.id} />
      ))}
    </div>
  );
};
